import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20soft%20silk%20and%20cotton%20fabric%20draped%20gracefully%20in%20warm%20blush%20rose%20and%20cream%20tones%2C%20gentle%20morning%20sunlight%20casting%20soft%20shadows%20on%20a%20minimalist%20neutral%20background%2C%20luxurious%20textile%20photography%2C%20feminine%20delicate%20aesthetic%2C%20clean%20composition%20with%20flowing%20fabric%20folds%2C%20editorial%20fashion%20vibe&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="优雅舒适的女性内裤面料展示"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          {heroData.title}
        </h1>
        <p className="text-lg md:text-xl text-white/90 font-heading italic mb-4">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={heroData.ctaLink}
            className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {heroData.ctaText}
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to={heroData.secondaryLink}
            className="inline-flex items-center px-8 py-3.5 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {heroData.secondaryText}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}